import { DocumentFile } from 'modules/domain/types'
import { FC } from 'react'
import styled, { css } from 'styled-components'
import { sutableImgExtensions, sutableVideoExtensions } from './FIlesControl/FilesControl'
import { Text } from '@agro-club/agroclub-shared'

const GalleryWrapper = styled.div`
  flex-shrink: 0;
  display: grid;
  gap: 2px;
  overflow: hidden;
  width: 420px;
`

const MediaWrapper = styled.div<{ spanColumns?: number; spanRows?: number }>`
  position: relative;
  overflow: hidden;
  background: #222;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  ${(props) =>
    props.spanColumns &&
    css`
      grid-column: span ${props.spanColumns};
    `}

  ${(props) =>
    props.spanRows &&
    css`
      grid-row: span ${props.spanRows};
    `}
`

const PlayIcon = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  &:after {
    content: '';
    width: 48px;
    height: 48px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    position: absolute;
  }

  &:before {
    content: '';
    position: absolute;
    border-left: 16px solid white;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    margin-left: 4px;
    z-index: 1;
  }
`

function getLayoutStyles(count) {
  if (count === 1) return { columns: '1fr' }

  if (count === 2) return { columns: '1fr 1fr' }

  if (count === 3)
    return {
      columns: '1fr 1fr',
      custom: (i) => (i === 0 ? { spanColumns: 2 } : {}),
    }

  if (count === 4) return { columns: '1fr 1fr' }

  if (count === 5)
    return {
      columns: '2fr 1fr 1fr',
      rows: '1fr 1fr',
      custom: (i) => (i === 0 ? { spanRows: 2 } : {}),
    }

  return {
    columns: '1fr 1fr 1fr',
    custom: (i) => (i === 0 ? { spanColumns: 3 } : {}),
  }
}

const MessengerGallery: FC<{ documents: DocumentFile[] }> = ({ documents }) => {
  const count = documents.length
  const layout = getLayoutStyles(count)

  return (
    <GalleryWrapper
      style={{
        gridTemplateColumns: layout.columns,
        gridTemplateRows: layout.rows || 'auto',
      }}
    >
      {documents.map((doc, index) => {
        let fileType = 'other'
        if (sutableImgExtensions.includes(doc.extension || '')) {
          fileType = 'img'
        } else if (sutableVideoExtensions.includes(doc.extension || '')) {
          fileType = 'video'
        }
        const customProps = layout.custom ? layout.custom(index) : {}

        return (
          <MediaWrapper key={index} {...customProps}>
            {fileType === 'img' && <img src={doc.uploaded_file} alt="" loading="lazy" />}

            {fileType === 'video' && (
              <>
                <video src={doc.uploaded_file} muted loop playsInline preload="metadata" />
                <PlayIcon />
              </>
            )}
            {fileType === 'other' && (
              <div style={{ height: 100, width: 100 }}>
                <Text color="primary">No Preview</Text>
              </div>
            )}
          </MediaWrapper>
        )
      })}
    </GalleryWrapper>
  )
}

export default MessengerGallery
